var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },
  {
    id: "reporting_period",
    label: "報告期分",
    error_if_blank:true,
    type: types.INPUT,
  },
  {
    id: "expiration_date_start",
    label: "開始期限",
    error_if_blank:true,
    type: types.DATE_PICKER,
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "expiration_date_end",
    label: "終了期限",
    error_if_blank:true,
    type: types.DATE_PICKER,
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "last_reporting_period",
    label: "前回報告期分",
    type: types.SELECT_BOX4,
    api:"/master_inventory_reporting_period/list_reporting_period",
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "editable",
    label: "編集許可",
    error_if_blank:true,    
    type: types.SELECT_BOX,
    default_value:"許可",
    options: [
      "許可", 
      "不許可",
    ],
    import: { enabled: true },
  },
  
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_master_inventory_reporting_period.js